<ion-grid class="app-updates">
  <ion-row>
    <ion-col>
      <ion-grid>
        <ion-row class="ion-justify-content-center ion-text-center">
          <ion-col size="auto">
            <ion-img [src]="logoSrcMap[appName]"></ion-img>
          </ion-col>

          <ion-col size="12" class="app-updates__heading">
            {{ updateType === 'FLEXIBLE' ? 'Update Available' : 'Update Required' }}
          </ion-col>
        </ion-row>

        <ion-row class="ion-justify-content-center ion-text-center app-updates__tag" *ngIf="updateType === 'IMMEDIATE'">
          <ion-col> To continue using {{ appName }}, please update the app to the latest version. </ion-col>
        </ion-row>

        <ion-row class="ion-justify-content-center ion-text-center ion-margin-vertical">
          <ion-col>
            {{
              updateType === 'FLEXIBLE'
                ? 'A new update is available with new features, performance improvements, and bug fixes. Updating ensures you get the best experience on ' +
                  appName +
                  '.'
                : 'This update includes important improvements, security fixes, and performance enhancements.'
            }}
          </ion-col>
        </ion-row>

        <ion-row
          *ngIf="currentVersionName && availableVersionName"
          class="ion-justify-content-center ion-align-items-center app-updates__versions"
        >
          <ion-col size="auto">v{{ currentVersionName }}</ion-col>
          <ion-col size="auto" class="app-updates__versions__icon">
            <ion-icon name="arrow-forward-outline"></ion-icon>
          </ion-col>
          <ion-col size="auto" class="app-updates__versions__latest">v{{ availableVersionName }}</ion-col>
        </ion-row>
      </ion-grid>
    </ion-col>
  </ion-row>

  <ion-row>
    <ion-col>
      <ui-custom-button
        expand="full"
        [btnTxt]="updateType === 'FLEXIBLE' ? 'Update Now' : 'Update'"
        (clickEvent)="updateNow()"
      ></ui-custom-button>
      <ui-custom-button
        *ngIf="updateType === 'FLEXIBLE'"
        buttonType="SECONDARY"
        expand="full"
        btnTxt="Later"
        (clickEvent)="close()"
      ></ui-custom-button>
    </ion-col>
  </ion-row>
</ion-grid>
